import {h} from 'preact';
import React, { Fragment } from 'react'

export default function FreeProFlag({free, isFreemium}) {
  return (
    <React.Fragment>
      {isFreemium && !free ? 
        <label class="free-pro-flag">
            <span class="pro"><img src={'https://musthavemenus.com/imageservice/images/img/13/pay-modal/Pro2.svg'} alt={''}/> PRO</span>
        </label>
      : ''}
    </React.Fragment>
  )
}
